import React, {useEffect} from 'react';
import {Navigate, Outlet, useParams} from 'react-router-dom';
import {useI18n} from '../../i18n/useI18n';
import {isSiteLocale} from '../../i18n/siteLocalePath';
import PublicSiteLayout from './PublicSiteLayout';

const LocalizedPublicSiteLayout: React.FC = () => {
    const {siteLocale} = useParams();
    const {locale, setLocale} = useI18n();

    useEffect(() => {
        if (siteLocale && isSiteLocale(siteLocale) && siteLocale !== locale) {
            setLocale(siteLocale);
        }
    }, [locale, setLocale, siteLocale]);

    if (!siteLocale || !isSiteLocale(siteLocale)) {
        return <Navigate replace to="/"/>;
    }

    return (
        <PublicSiteLayout>
            <Outlet/>
        </PublicSiteLayout>
    );
};

export default LocalizedPublicSiteLayout;
